import React, { useState } from "react";
import "./Testimonials.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Testimonials = () => {
  const data = [
    {
      review:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi.",
      img: "/assets/images/testimonials/img1.png",
      name: "Ankit Gupta",
      desgn: "(Corporate Team Lead)",
    },
    {
      review:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi.",
      img: "/assets/images/testimonials/img1.png",
      name: "Rohit Sharma",
      desgn: "(Professional Athlete)",
    },
    {
      review:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi.",
      img: "/assets/images/testimonials/img1.png",
      name: "Smita Laad",
      desgn: "(Corporate Team Lead)",
    },
    {
      review:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi.",
      img: "/assets/images/testimonials/img1.png",
      name: "Smita Laad",
      desgn: "(Corporate Team Lead)",
    },
    {
      review:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi.",
      img: "/assets/images/testimonials/img1.png",
      name: "Smita Laad",
      desgn: "(Corporate Team Lead)",
    },
  ];

  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleMainSliderClick = (direction) => {
    console.log("swiperInstance", swiperInstance, direction);

    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  return (
    <section className="Testimonials">
      <div className="container">
        <div className="main_content_div">
          <Heading_title
            title={"Testimonials"}
            subtitle={
              "See what our participants and partners say about their journey with us."
            }
          />

          <div className="swiper_div">
            <Swiper
              onSwiper={setSwiperInstance}
              slidesPerView={1}
              spaceBetween={10}
              modules={[Navigation]}
              breakpoints={{
                "0": {
                  slidesPerView: 1.2,
                  spaceBetween: 0,
                },
                "350": {
                  slidesPerView: 1.3,
                  spaceBetween: 0,
                },
                "450": {
                  slidesPerView: 1.6,
                  spaceBetween: 0,
                },
                "575": {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                "768": {
                  slidesPerView: 2.5,
                  spaceBetween: 10,
                },
                "992": {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                "1200": {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                "1400": {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              }}
              centeredSlides={true}
              loop={true}
              className="mySwiper"
            >
              {data.map((item, index) => (
                <SwiperSlide>
                  <div className="white_review_card">
                    <div className="quote_img_div">
                      <img
                        src="/assets/images/testimonials/quote.png"
                        className="quote_img"
                      />
                    </div>

                    <p className="review_text">{item?.review}</p>

                    <div className="img_holder">
                      <img
                        src={process.env.PUBLIC_URL + item?.img}
                        className="profile_img"
                      />
                    </div>
                    <p className="name_text">{item?.name}</p>
                    <p className="desgn_text">{item?.desgn}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* <div className="silder_btn"> */}
              <div className="back_btn_holder" onClick={() => handleMainSliderClick("prev")}>
                <div
                  className="back_btn"
                  
                >
                  <p>
                    {" "}
                    <FontAwesomeIcon icon={faAngleLeft} className="icon" />
                  </p>
                </div>
              </div>
              <div className="back_btn_holder next" onClick={() => handleMainSliderClick("next")}>
                <div
                  className="back_btn"
                  
                >
                  <p>
                    {" "}
                    <FontAwesomeIcon icon={faAngleRight} className="icon" />
                  </p>
                </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
